import { createAction } from '@reduxjs/toolkit'

export const hideSpinner = createAction('hideSpinner')
export const showSpinner = createAction('showSpinner')



